export const ErrorCode = {
  COMPANY_ALREADY_EXISTS: 'COMPANY_ALREADY_EXISTS',
  COMPANY_EXTERNAL_VERIFICATION_FAILED: 'COMPANY_EXTERNAL_VERIFICATION_FAILED',
};
